import { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import { LOCALES } from "@/locales/landing";

/**
 * Press-release landing page — a shareable localized URL for ethnic
 * newspapers, radio, and community outreach.
 *
 * Route: /press/:lang  (e.g. /press/es, /press/zh, /press/vi, /press/tl,
 * /press/ko, /press/hi). Renders the main LandingPage in the requested
 * locale, adds a `?utm_source=press&utm_medium=community&utm_campaign=<lang>`
 * tag for attribution, and stores the referral in localStorage so we can
 * track which press channel converted a visitor.
 */
export default function PressLandingPage() {
  const { lang } = useParams();
  const supported = new Set(LOCALES.map((l) => l.code));
  const locale = supported.has(lang) ? lang : "en";

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const source = params.get("utm_source") || "press";
      const campaign = params.get("utm_campaign") || `press_${locale}`;
      // Record for attribution — read at sign-up time by the auth flow.
      localStorage.setItem("ds260_referral_source", source);
      localStorage.setItem("ds260_referral_campaign", campaign);
      localStorage.setItem("ds260_referral_locale", locale);
    } catch (err) {
      // localStorage can be unavailable in private mode
      console.warn("[PressLanding] attribution not stored:", err);
    }
  }, [locale]);

  // Fall back to canonical /en URL if the language isn't supported.
  if (!supported.has(lang)) {
    return <Navigate to="/" replace />;
  }
  return <LandingPage locale={locale} />;
}
